function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M88 16.124c0-2.145 2.92-2.785 3.817-.836l2.275 4.94a1 1 0 001.816 0l4.275-9.283c.715-1.552 2.919-1.552 3.634 0l4.275 9.283a1 1 0 001.816 0l4.275-9.283c.715-1.552 2.919-1.552 3.634 0l4.275 9.283a1 1 0 001.816 0l4.275-9.283c.715-1.552 2.919-1.552 3.634 0l4.275 9.283a1 1 0 001.816 0l2.275-4.94c.898-1.95 3.817-1.31 3.817.836V35c0 5.523-4.477 10-10 10H98c-5.523 0-10-4.477-10-10V16.124z",
  fill: "#FFB900"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M88 27.124c0-2.145 2.92-2.785 3.817-.836l2.275 4.94a1 1 0 001.816 0l4.275-9.283c.715-1.552 2.919-1.552 3.634 0l4.275 9.283a1 1 0 001.816 0l4.275-9.283c.715-1.552 2.919-1.552 3.634 0l4.275 9.283a1 1 0 001.816 0l4.275-9.283c.715-1.552 2.919-1.552 3.634 0l4.275 9.283a1 1 0 001.816 0l2.275-4.94c.898-1.95 3.817-1.31 3.817.836V38c0 5.523-4.477 10-10 10H98c-5.523 0-10-4.477-10-10V27.124z",
  fill: "#FF5520"
});

function SvgAccessories3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 232,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/media/accessories-3.26cb0d1d.svg";
export { SvgAccessories3 as ReactComponent };